import { render, staticRenderFns } from "./NodeProject.vue?vue&type=template&id=4d91a15a&lang=pug&"
import script from "./NodeProject.vue?vue&type=script&lang=js&"
export * from "./NodeProject.vue?vue&type=script&lang=js&"
import style0 from "./NodeProject.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d91a15a')) {
      api.createRecord('4d91a15a', component.options)
    } else {
      api.reload('4d91a15a', component.options)
    }
    module.hot.accept("./NodeProject.vue?vue&type=template&id=4d91a15a&lang=pug&", function () {
      api.rerender('4d91a15a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/docs/NodeProject.vue"
export default component.exports